import { Table as TanstackTable } from "@tanstack/react-table";
import {
  TableCell,
  TableRow,
} from "modules/common/components/Table/TableComponents";
import { ColumnSkeleton } from "modules/common/components/Table/ColumnSkeleton";
import { resolveColumnWidthStyle } from "modules/common/components/Table/columnWidth";

export function TableRowSkeleton<T>({ table }: { table: TanstackTable<T> }) {
  // Get all columns that are currently visible
  const visibleColumns = table.getVisibleLeafColumns();

  return (
    <TableRow>
      {visibleColumns.map((column) => (
        <TableCell
          key={column.id}
          className={`${column.columnDef.meta?.className}`}
          style={resolveColumnWidthStyle(column.columnDef)}
        >
          <ColumnSkeleton column={column.columnDef} />
        </TableCell>
      ))}
    </TableRow>
  );
}
